












































import { Component, Vue } from "vue-property-decorator";
import { getIntegration } from "@/services/api";
import {Integration, IntegrationMap} from "@/model/Integration";
import YcHeader from "@/components/common/yc-header.vue";
import YcAside from "@/components/common/yc-aside.vue";

@Component({
  components: {
    "yc-aside": YcAside,
    "yc-header": YcHeader,
  },
})
export default class DataAccess extends Vue {
  public activeTab = "all";
  public integrationMap: IntegrationMap = {
    added: [],
    all: [],
  };

  /**
   * default integrationMap data
   */
  public defaultData: Integration[] = [
    {
      platform: "Shopify",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/shopify.png"),
      shopURL: ""
    },
    {
      platform: "Funpinpin",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/funpinpin.png"),
      shopURL: ""
    },
    {
      platform: "Shoplazza",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/shoplazza.png"),
      shopURL: ""
    },
    {
      platform: "Allvalue",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/allvalue.png"),
      shopURL: ""
    },
    {
      platform: "ActBlue",
      subTitle: "Fundraising",
      icon: require("@/assets/img/integrations/actblue.png"),
      shopURL: ""
    },
    {
      platform: "AfterShip",
      subTitle: "Shipping",
      icon: require("@/assets/img/integrations/aftership.png"),
      shopURL: ""
    },
    {
      platform: "BigCommerce",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/bigcommerce.png"),
      shopURL: ""
    },
    {
      platform: "Chargebee",
      subTitle: "Payments",
      icon: require("@/assets/img/integrations/chargebee.png"),
      shopURL: ""
    },
    {
      platform: "Classy",
      subTitle: "Fundraising",
      icon: require("@/assets/img/integrations/classy.png"),
      shopURL: ""
    },

    {
      platform: "DonorPerfect",
      subTitle: "Fundraising",
      icon: require("@/assets/img/integrations/donorperfect.png"),
      shopURL: ""
    },
    {
      platform: "Eventbrite",
      subTitle: "Event Management",
      icon: require("@/assets/img/integrations/eventbrite.png"),
      shopURL: ""
    },
    {
      platform: "Facebook Advertising",
      subTitle: "Advertising",
      icon: require("@/assets/img/integrations/facebook.png"),
      shopURL: ""
    },
    {
      platform: "Funraise",
      subTitle: "Fundraising",
      icon: require("@/assets/img/integrations/funraise.png"),
      shopURL: ""
    },
    {
      platform: "Gorgias",
      subTitle: "Help Desk",
      icon: require("@/assets/img/integrations/gorgias.png"),
      shopURL: ""
    },
    {
      platform: "Help Scout",
      subTitle: "Help Desk",
      icon: require("@/assets/img/integrations/helpscout.png"),
      shopURL: ""
    },
    {
      platform: "KickoffLabs",
      subTitle: "Forms",
      icon: require("@/assets/img/integrations/kickofflabs.png"),
      shopURL: ""
    },
    {
      platform: "Lightspeed",
      subTitle: "Point Of Sales",
      icon: require("@/assets/img/integrations/lightspeed.png"),
      shopURL: ""
    },
    {
      platform: "MadMimi",
      subTitle: "Email",
      icon: require("@/assets/img/integrations/madmimi.png"),
      shopURL: ""
    },
    {
      platform: "Magento",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/magento.png"),
      shopURL: ""
    },
    {
      platform: "Magento 2",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/magento2.png"),
      shopURL: ""
    },
    {
      platform: "Mailchimp",
      subTitle: "Email",
      icon: require("@/assets/img/integrations/mailchimp.png"),
      shopURL: ""
    },
    {
      platform: "Mi9",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/mi9.png"),
      shopURL: ""
    },
    {
      platform: "NeonCRM",
      subTitle: "Fundraising",
      icon: require("@/assets/img/integrations/neoncrm.png"),
      shopURL: ""
    },
    {
      platform: "Olark",
      subTitle: "Help Desk",
      icon: require("@/assets/img/integrations/olark.png"),
      shopURL: ""
    },
    {
      platform: "OpenCart",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/opencart.png"),
      shopURL: ""
    },
    {
      platform: "PrestaShop",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/prestashop.png"),
      shopURL: ""
    },
    {
      platform: "Qgiv",
      subTitle: "Fundraising",
      icon: require("@/assets/img/integrations/qgiv.png"),
      shopURL: ""
    },
    {
      platform: "ReCharge",
      subTitle: "Payments",
      icon: require("@/assets/img/integrations/recharge.png"),
      shopURL: ""
    },
    {
      platform: "Recurly",
      subTitle: "Payments",
      icon: require("@/assets/img/integrations/recurly.png"),
      shopURL: ""
    },
    {
      platform: "Salesforce",
      subTitle: "CRM",
      icon: require("@/assets/img/integrations/salesforce.png"),
      shopURL: ""
    },
    {
      platform: "Salesforce Commerce Cloud",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/salesforce.png"),
      shopURL: ""
    },
    {
      platform: "Salesforce Marketing Cloud",
      subTitle: "Email",
      icon: require("@/assets/img/integrations/salesforce.png"),
      shopURL: ""
    },
    {
      platform: "Segment",
      subTitle: "Api",
      icon: require("@/assets/img/integrations/segment.png"),
      shopURL: ""
    },
    {
      platform: "ShipStation",
      subTitle: "Shipping",
      icon: require("@/assets/img/integrations/shipstation.png"),
      shopURL: ""
    },
    {
      platform: "Spree",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/spree.png"),
      shopURL: ""
    },
    {
      platform: "Stripe",
      subTitle: "Payments",
      icon: require("@/assets/img/integrations/stripe.png"),
      shopURL: ""
    },
    {
      platform: "Typeform",
      subTitle: "Forms",
      icon: require("@/assets/img/integrations/typeform.png"),
      shopURL: ""
    },
    {
      platform: "Unbounce",
      subTitle: "Forms",
      icon: require("@/assets/img/integrations/unbounce.png"),
      shopURL: ""
    },
    {
      platform: "Volusion",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/volusion.png"),
      shopURL: ""
    },
    {
      platform: "WooCommerce",
      subTitle: "eCommerce",
      icon: require("@/assets/img/integrations/woocommerce.png"),
      shopURL: ""
    },
    {
      platform: "Wufoo",
      subTitle: "Forms",
      icon: require("@/assets/img/integrations/wufoo.png"),
      shopURL: ""
    },
    {
      platform: "Zendesk",
      subTitle: "Help Desk",
      icon: require("@/assets/img/integrations/zendesk.png"),
      shopURL: ""
    },
    {
      platform: "Zoho",
      subTitle: "CRM",
      icon: require("@/assets/img/integrations/zoho.png"),
      shopURL: ""
    },
  ];

  created(): void {
    this.getIntegration();
  }

  getIntegration(): void {
    getIntegration({}).then((res) => {
      const { added, all } = res.data.data;
      const platformSet = all.map(item => item.platform)
      this.integrationMap.all = [
        ...all.filter(item => item.platform !== '手动导入').map(item => ({...item, support: true})),
        ...this.defaultData.filter(item => !platformSet.includes(item.platform))
      ].sort((a,b) => a.shopURL && !b.shopURL?-1:1);
      this.integrationMap.added = added;
    });
  }
}
